module.exports = __webpack_public_path__ + "static/media/wizualizacja-140.a7470a68.png";